import { defineMessages } from 'react-intl';

const messages = defineMessages({
  cancelEmailHeader: {
    description: 'Modal Header Cancel Email Invite',
    defaultMessage: 'Cancel Email Invite – {vendorName}',
    id: 'YYDVLI',
  },
  errorBannerText: {
    description: 'Banner indicating an error occurred during the action',
    defaultMessage: 'An error occurred while attempting to update the settings. Please try again.',
    id: 'j9swa4',
  },
  shipstationAccount: {
    description: 'ShipStations specific Carriers modal sub-header label',
    defaultMessage: 'ShipStation Account',
    id: '4f8QkW',
  },
  cancelInviteModalBodyText: {
    description: 'Message warning user that this action will prevent the vendor from accepting the invite',
    defaultMessage:
      'Are you sure you want to cancel your email invite to {vendorName}? This will invalidate the link in the invite email, preventing them from connecting to your account.',
    id: '3DzIBE',
  },
  nameInputLabel: {
    description: 'Nickname Associated to Vendor',
    defaultMessage: 'Vendor Name',
    id: 'v2gbLf',
  },
  cancelInviteButton: {
    description: 'Cancel Invite button',
    defaultMessage: 'Cancel Invite',
    id: 'NASO4X',
  },
  cancelButton: {
    description: 'Cancel button',
    defaultMessage: 'Cancel',
    id: 'qz9XeG',
  },
  keepInviteButton: {
    description: 'Keep Invite button',
    defaultMessage: 'Keep Invite',
    id: 'J6d7lb',
  },
});

export default messages;
